import { makeStyles } from '@material-ui/core/styles';
import colors from "../../foundations/colors.module.scss";
import typography from "../../foundations/typography.module.scss";
const standardColor = colors.dark700;
const standardBorderColor = colors.dark900;
const disabledColor = colors.dark300;
const disabledBorderColor = colors.dark300;
const focusedColor = colors.purple800;
export const useKeyboardDatePickerStyles = makeStyles({
  helperText: {
    fontSize: 12,
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0,
    '&.positionFixed': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      transform: 'translateY(100%)'
    },
    width: '100%',
    lineHeight: 'normal'
  },
  label: {
    fontFamily: typography.fontFamilyLight,
    color: standardColor,
    fontSize: typography.fontSizeP1,
    '&.Mui-disabled': {
      color: disabledColor
    },
    '&.Mui-focused': {
      color: focusedColor
    }
  },
  input: {
    fontFamily: typography.fontFamilyLight,
    color: standardColor,
    fontSize: typography.fontSizeP1,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: standardBorderColor
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: standardBorderColor,
      borderWidth: 2
    },
    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: focusedColor
      }
    },
    '&.Mui-disabled': {
      color: disabledColor,
      '& .MuiOutlinedInput-notchedOutline': {
        borderWidth: 1,
        borderColor: disabledBorderColor
      },
      '& .MuiOutlinedInput-input': {
        color: disabledColor
      }
    }
  },
  inputInput: _ref => {
    let {
      isDisabled
    } = _ref;
    return {
      lineHeight: '24px',
      paddingTop: 4,
      paddingBottom: 4,
      cursor: isDisabled ? 'default' : 'pointer'
    };
  },
  inputInput_medium: {
    height: 38
  },
  inputInput_small: {
    height: 32
  },
  adornedEnd: {
    paddingRight: 0
  }
});